export const PROJECTS = [
  {
    slug: "harman-ai-solutions",
    featured: true,
    name: "Harman AI Solutions",
    desc: "Our own business website — showcasing the design and development capabilities behind every project we build.",
    image: "/assets/harman-site.png",
    url: "https://harmanaisolutions.com",
    accent: "from-[#087CFF] to-[#39D5FF]",
  },
  {
    slug: "conan",
    name: "Plumbing & Drain Cleaning Business",
    desc: "A professional site for a multi-service plumbing and drain cleaning company, helping local customers find and get in touch quickly.",
    image: "/assets/conan.png",
    url: "https://conansharmanplumbing.co.uk/",
    accent: "from-[#1745FF] to-[#00A8FF]",
  },
  {
    slug: "innovators-prep",
    name: "Early Childhood Education Consultancy",
    desc: "A modern, professional site for a NYC-based early childhood education consultancy, helping parents navigate the 2-K, 3-K, and Pre-K application process.",
    image: "/assets/innovators.png",
    url: "https://innovatorsprepnyc.com",
    accent: "from-[#1745FF] to-[#00A8FF]",
  },
  { slug: "placeholder-1", accent: "from-[#00A8FF] to-[#45E0B5]" },
];